import { FLAG_SEVERITY_ORDER } from 'constants/forms';

export const sumFlagCounts = countsList =>
  countsList.reduce((total, counts) => {
    FLAG_SEVERITY_ORDER.forEach(severity => {
      total[severity] = (total[severity] || 0) + (counts?.[severity] || 0);
    });
    return total;
  }, {});

export const worstSeverity = counts =>
  FLAG_SEVERITY_ORDER.find(severity => counts?.[severity] > 0) || null;

export const refereeFlagCounts = (flagCounts, referee) =>
  sumFlagCounts(Object.values(flagCounts?.by_referee?.[referee.id] || {}));

export const checkFormIds = check =>
  (check.sub_checks?.length > 0
    ? check.sub_checks.map(subCheck => subCheck.details?.id)
    : [check.details?.form_id]
  ).filter(Boolean);

export const checkFlagSeverity = (flagCounts, check) =>
  worstSeverity(sumFlagCounts(checkFormIds(check).map(formId => flagCounts?.by_form?.[formId])));

export const refereeWorstSeverity = (flagCounts, referee) =>
  worstSeverity(refereeFlagCounts(flagCounts, referee));
